export type RolePayload = {
	readonly id: number;
	readonly name: string;
	readonly label: string;
	readonly description: string | null;
	readonly isSystem: boolean;
	readonly isActive: boolean;
	// Bare permission strings, not `{ value, label }`: `Role.permissions` is a plain array property,
	// never serialized through the enum registry. Labels come from the permission catalogue.
	readonly permissions: readonly string[];
	readonly assignedUserCount: number;
};

export type RolesListFetchedPayload = {
	readonly totalRecords: number;
	readonly results: readonly RolePayload[];
};

export type RolesFetchedAction = {
	type: 'ROLES_FETCHED';
	payload: RolesListFetchedPayload;
	accountId: number;
};

export default (payload: RolesListFetchedPayload, accountId: number): RolesFetchedAction => ({
	type: 'ROLES_FETCHED',
	payload,
	accountId,
});
